export const paths = {
  // Public routes
  login: '/login',

  // Protected routes
  dashboard: '/dashboard',
  profile: '/profile',
  profileEdit: '/profile/edit',

  // Products module
  products: '/products',
  productCreate: '/products/create',
  productEdit: (id: string) => `/products/${id}/edit`,

  // Orders module
  orders: '/orders',

  // Feed module
  feeds: '/feeds',
  feedCreate: '/feeds/create',
  feedEdit: (id: string) => `/feeds/${id}/edit`,
  feedDetail: (id: string) => `/feeds/${id}/detail`,

  // Articles module (Admin only)
  articles: '/articles',
  articleCreate: '/articles/create',
  articleEdit: (id: string) => `/articles/${id}/edit`,

  // Shops module (Admin only)
  shops: '/shops',
  shopCreate: '/shops/create',
  shopEdit: (id: string) => `/shops/${id}/edit`,

  // Programs module (Admin only)
  programs: '/programs',
  programCreate: '/programs/create',
  programEdit: (id: string) => `/programs/${id}/edit`,
  programManage: (id: string) => `/programs/${id}/manage`,

  // QR Code page
  qrCode: '/qr-code',

  // Privilege module (Admin only)
  privileges: '/privileges',
  privilegeCreate: '/privileges/create',
  privilegeEdit: (id: string) => `/privileges/${id}/edit`,
  redeemCondition: (id: string) => `/privileges/${id}/redeem-condition`,

  // Order privilege module (Admin only)
  orderPrivileges: '/order-privileges',

  // Bank payment page
  bankPayment: '/bank-payment',

  // Rooster match module
  roosterMatch: '/rooster-match',

  // Arena module
  arenas: '/arenas',
  arenaCreate: '/arenas/create',
  arenaEdit: (id: string) => `/arenas/${id}/edit`,
  // Transfer token
  transferToken: '/transfer-token',
  // Trend Sounds module (Admin only)
  trendSounds: '/trend-sounds',
  trendSoundCreate: '/trend-sounds/create',
  trendSoundEdit: (id: string) => `/trend-sounds/${id}/edit`,

  // Trends module (Admin only)
  trends: '/trends',

  // Clip Categories module (Admin only)
  clipCategories: '/clip-categories',

  // Clips module (Admin only)
  clips: '/clips',
  clipCreate: '/clips/create',
  clipEdit: (id: string) => `/clips/${id}/edit`,
}

export const PATH_AFTER_LOGIN = paths.dashboard
